import { PromoBannersIdFiltersType } from '../containers/PromoBannersIdFiltersForm/PromoLandingsFiltersForm.types'

export const PROMO_BANNERS_ID_DEFAULT_FILTERS: PromoBannersIdFiltersType = {
  fileFormats: [],
  imageSizes: [],
  locales: [],
}
